import { type OpenDropdownAction } from 'src/types';

import { DROPDOWN_KEY } from '../constants/Dropdown';
import { ViewActions } from '../constants/ViewActions';
import { Map } from '../lib/ImmutableUtils';
import { createReducer } from '../lib/ReducerUtils';

const INITIAL_STATE = Map({
  [DROPDOWN_KEY]: [] as $TSFixMe,
});
export type DropdownState = typeof INITIAL_STATE;

// DROPDOWN REDUCER
export default createReducer(INITIAL_STATE, {
  [ViewActions.OPEN_DROPDOWN]: openDropdown,
  [ViewActions.CLOSE_DROPDOWN]: closeDropdown,
});

// CASE FUNCTIONS
function openDropdown(_state: DropdownState, { payload }: OpenDropdownAction): DropdownState {
  return Map({
    [DROPDOWN_KEY]: payload.dropdownConfiguration,
  });
}

function closeDropdown(): DropdownState {
  return INITIAL_STATE;
}
